module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<section \n    <% if (typeof customClass !== 'undefined') { %>\n        class=\"js-le-carousel <%= customClass %>\"\n    <% } else { %>\n        class=\"js-le-carousel\"\n    <% } %>\n         data-displayId=\"<% if (typeof displayId !== 'undefined') { %><%= displayId %><% } %>\"\n         data-recoId=\"<% if (typeof recoId !== 'undefined') { %><%= recoId %><% } %>\"\n    <% if(typeof carouselId !== 'undefined') { %>\n        data-carouselId=\"<%= carouselId %>\"\n     <% } %>\n    <% if(typeof isContentHighlightEnabled !== 'undefined') { %>\n        data-isContentHighlightEnabled=\"<%= isContentHighlightEnabled %>\"\n    <% } %>\n    <% if(typeof rankModel !== 'undefined') { %>\n        data-rankModel=\"<%= rankModel %>\"\n    <% } %>\n         id=\"<% if (typeof id !== 'undefined') { %><%= id %><% } %>\"\n         data-title=\"<% if (typeof title !== 'undefined') { %><%= title %><% } %>\"\n         data-model=\"<% if (typeof model !== 'undefined') { %><%= model %><% } %>\"\n         data-position=\"<% if (typeof position !== 'undefined') { %><%= position %><% } %>\"\n    <% if (typeof dataCi !== 'undefined') { %>\n        data-ci=\"<%= dataCi %>\"\n    <% } %>\n\n    <% if (typeof carouselPresentationStyle !== 'undefined') { %>\n        data-presentationStyle=\"<%= carouselPresentationStyle %>\"\n    <% } %>\n>\n    <div class=\"carousel-content\">\n        <div class=\"carousel-width-wrapper\">\n            <div class=\"carousel js-video-carousel hidden\" \n                id=\"<% if (typeof id !== 'undefined') { %><%= id %><% } %>\" \n                data-displayId=\"<% if (typeof displayId !== 'undefined') { %><%= displayId %><% } %>\">\n            </div>\n        </div>\n    </div>\n</section>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/wrapper.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<section \n    ")
    ; __line = 2
    ;  if (typeof customClass !== 'undefined') { 
    ; __append("\n        class=\"js-le-carousel ")
    ; __line = 3
    ; __append(escapeFn( customClass ))
    ; __append("\"\n    ")
    ; __line = 4
    ;  } else { 
    ; __append("\n        class=\"js-le-carousel\"\n    ")
    ; __line = 6
    ;  } 
    ; __append("\n         data-displayId=\"")
    ; __line = 7
    ;  if (typeof displayId !== 'undefined') { 
    ; __append(escapeFn( displayId ))
    ;  } 
    ; __append("\"\n         data-recoId=\"")
    ; __line = 8
    ;  if (typeof recoId !== 'undefined') { 
    ; __append(escapeFn( recoId ))
    ;  } 
    ; __append("\"\n    ")
    ; __line = 9
    ;  if(typeof carouselId !== 'undefined') { 
    ; __append("\n        data-carouselId=\"")
    ; __line = 10
    ; __append(escapeFn( carouselId ))
    ; __append("\"\n     ")
    ; __line = 11
    ;  } 
    ; __append("\n    ")
    ; __line = 12
    ;  if(typeof isContentHighlightEnabled !== 'undefined') { 
    ; __append("\n        data-isContentHighlightEnabled=\"")
    ; __line = 13
    ; __append(escapeFn( isContentHighlightEnabled ))
    ; __append("\"\n    ")
    ; __line = 14
    ;  } 
    ; __append("\n    ")
    ; __line = 15
    ;  if(typeof rankModel !== 'undefined') { 
    ; __append("\n        data-rankModel=\"")
    ; __line = 16
    ; __append(escapeFn( rankModel ))
    ; __append("\"\n    ")
    ; __line = 17
    ;  } 
    ; __append("\n         id=\"")
    ; __line = 18
    ;  if (typeof id !== 'undefined') { 
    ; __append(escapeFn( id ))
    ;  } 
    ; __append("\"\n         data-title=\"")
    ; __line = 19
    ;  if (typeof title !== 'undefined') { 
    ; __append(escapeFn( title ))
    ;  } 
    ; __append("\"\n         data-model=\"")
    ; __line = 20
    ;  if (typeof model !== 'undefined') { 
    ; __append(escapeFn( model ))
    ;  } 
    ; __append("\"\n         data-position=\"")
    ; __line = 21
    ;  if (typeof position !== 'undefined') { 
    ; __append(escapeFn( position ))
    ;  } 
    ; __append("\"\n    ")
    ; __line = 22
    ;  if (typeof dataCi !== 'undefined') { 
    ; __append("\n        data-ci=\"")
    ; __line = 23
    ; __append(escapeFn( dataCi ))
    ; __append("\"\n    ")
    ; __line = 24
    ;  } 
    ; __append("\n\n    ")
    ; __line = 26
    ;  if (typeof carouselPresentationStyle !== 'undefined') { 
    ; __append("\n        data-presentationStyle=\"")
    ; __line = 27
    ; __append(escapeFn( carouselPresentationStyle ))
    ; __append("\"\n    ")
    ; __line = 28
    ;  } 
    ; __append("\n>\n    <div class=\"carousel-content\">\n        <div class=\"carousel-width-wrapper\">\n            <div class=\"carousel js-video-carousel hidden\" \n                id=\"")
    ; __line = 33
    ;  if (typeof id !== 'undefined') { 
    ; __append(escapeFn( id ))
    ;  } 
    ; __append("\" \n                data-displayId=\"")
    ; __line = 34
    ;  if (typeof displayId !== 'undefined') { 
    ; __append(escapeFn( displayId ))
    ;  } 
    ; __append("\">\n            </div>\n        </div>\n    </div>\n</section>\n")
    ; __line = 39
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/wrapper.tpl"

}